<div class="d-flex frame-setup-container" style="cursor: pointer;" *ngFor="let preset of userPresets"
  (click)="openCollageSetup(collageSetup, preset)">
  <div class="frame-content">
    <p translate>settings.preset<span style="font-weight: bold;">: {{preset?.name}}</span></p>
    <p translate>user.collages<span class="ml-1" style="font-weight: bold;">{{preset?.collage == null ? 'settings.noCollage' : preset?.collage?.name}}</span>
    </p>
  </div>
  <div class="root-application-bg frame-image"
    [style.background-image]="(preset?.collagePreview != null) ? 'url(' + preset?.collagePreview + ')' : 'url(assets/img/no-image.png)'">
  </div>
</div>

<!-- COLLAGE SETUP -->
<ng-template #collageSetup let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{selectedPresetForCollage.name}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row" style="display: flex !important;">
      <div class="d-flex justify-content-between frames-container">
        <div>
          <div class="frame-img" [style.border]="(!selectedCollageSetup) ? '2px solid red' : null"
            (click)="selectCollage(null)" [style.background-image]="'url(assets/img/no-image.png)'">
          </div>
          <p translate>user.withoutCollage</p>
        </div>
        <div *ngFor="let collage of collages">
          <div class="frame-img m-auto" (click)="selectCollage(collage)"
            [style.border]="(selectedCollageSetup && selectedCollageSetup.id == collage.id) ? '2px solid red' : null"
            [style.background-image]="(collage?.preview != null) ? 'url(' + collage?.preview + ')' : 'url(assets/img/no-image.png)'">
          </div>
          <p>{{collage.name}}</p>
        </div>
      </div>

      <form class="w-100" #collageAssignForm="ngForm">
        <div *ngIf="selectedCollageSetup">
          <div class="d-flex justify-content-between" style="width: 95%; margin: auto; overflow-x: auto;" *ngIf="selectedPresetForCollage?.collage?.type !== 'gif' || currentUser.role.name === 'root'">
            <div class="position-container" *ngFor="let position of selectedCollageSetup.dynamicPositions">
              <div class="frame-img collage_targets" *ngIf="position?.target != null"
                (click)="openSelectTarget(targets, position)"
                [style.background-image]="(position?.target != null) ? 'url(' + position?.target?.tutorialFile?.fileInfo.path + ')' : 'none'">
                <div class="overlay">Select Position</div>
              </div>
              <div class="frame-img collage_targets" *ngIf="position?.target == null"
                (click)="openSelectTarget(targets, position)">
                <div class="overlay">Select Position</div>
                {{position.key}}
              </div>
            </div>
          </div>

          <div style="width: 95%; margin: auto">
            <div class="d-flex" style="margin: 10px 0;" *ngFor="let text of selectedCollageSetup.dynamicTexts">
              <input type="text" class="form-control" name="{{text.key}}"
                [placeholder]="text.required ? text.key +' (required)' : text.key" (input)="isEmpty(text)"
                [(ngModel)]="text.value" [required]="text.required">
            </div>
          </div>
        </div>

        <button class="btn btn-default custom-button" style="margin: 12px;" [disabled]="!collageAssignForm.valid"
          (click)="assignCollage()" translate>global.save</button>
      </form>

    </div>
  </div>
</ng-template>

<ng-template #targets let-c="close" let-d="dismiss">
  <div class="d-flex" style="flex-wrap: wrap;">
    <div class="p-1" *ngFor="let target of selectedPresetForCollage.targets">
      <div class="frame-img" (click)="selectTarget(target)"
        [style.background-image]="(target?.tutorialFile != null) ? 'url(' + target?.tutorialFile?.fileInfo.path + ')' : 'url(assets/img/no-image.png)'">
      </div>
      <p style="margin: 0; text-align: center;">{{target.position}}</p>
    </div>
  </div>
</ng-template>